"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductVariantsInnerTrimRgbToJSON = exports.ProductVariantsInnerTrimRgbFromJSONTyped = exports.ProductVariantsInnerTrimRgbFromJSON = exports.instanceOfProductVariantsInnerTrimRgb = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ProductVariantsInnerTrimRgb interface.
 */
function instanceOfProductVariantsInnerTrimRgb(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductVariantsInnerTrimRgb = instanceOfProductVariantsInnerTrimRgb;
function ProductVariantsInnerTrimRgbFromJSON(json) {
    return ProductVariantsInnerTrimRgbFromJSONTyped(json, false);
}
exports.ProductVariantsInnerTrimRgbFromJSON = ProductVariantsInnerTrimRgbFromJSON;
function ProductVariantsInnerTrimRgbFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'r': !(0, runtime_1.exists)(json, 'r') ? undefined : json['r'],
        'b': !(0, runtime_1.exists)(json, 'b') ? undefined : json['b'],
        'g': !(0, runtime_1.exists)(json, 'g') ? undefined : json['g'],
    };
}
exports.ProductVariantsInnerTrimRgbFromJSONTyped = ProductVariantsInnerTrimRgbFromJSONTyped;
function ProductVariantsInnerTrimRgbToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'r': value.r,
        'b': value.b,
        'g': value.g,
    };
}
exports.ProductVariantsInnerTrimRgbToJSON = ProductVariantsInnerTrimRgbToJSON;
